<body>
  <app-nav-menu></app-nav-menu>
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
</body>
